// Share a Top Movies ranking: a poster image (square for feeds, story for
// Stories / TikTok) and — once the list is saved and public — its link.
//
// The image is the same server-rendered card as the link preview. Unsaved and
// guest rankings use the id-only card (no hosted list, no name on it); a saved
// public list uses its own card, which carries @username.
//
// The panel itself is the shared PosterSharePanel; this wrapper supplies the
// Top Movies URLs, copy and analytics (top_movies_* events + the funnel log).
import { useCallback } from 'react';
import { TopMoviesService } from '../../services/topMoviesService';
import PosterSharePanel, { IMAGE_FORMATS } from '../PosterShare/PosterSharePanel';
import { ANALYTICS_EVENTS } from '../../analytics';
import { trackTopMovies } from '../../analytics/topMoviesAnalytics';

export { IMAGE_FORMATS };

export default function TopMoviesSharePanel({ movies, size, ranked, shared = null, loggedIn = false, sourceScreen = 'creator' }) {
    const imageUrlFor = useCallback((format) => (shared?.slug
        ? TopMoviesService.sharedCardUrl(shared.slug, { format })
        : TopMoviesService.draftCardUrl({ movies, size, ranked, format })), [shared?.slug, movies, size, ranked]);

    const onTrack = useCallback((kind, params) => {
        const event = kind === 'image_exported' ? ANALYTICS_EVENTS.TOP_MOVIES_IMAGE_EXPORTED : ANALYTICS_EVENTS.TOP_MOVIES_SHARE_CLICKED;
        trackTopMovies(event, { size, ranked, logged_in: loggedIn, source_screen: sourceScreen, ...params }, { listSlug: shared?.slug });
    }, [size, ranked, loggedIn, sourceScreen, shared?.slug]);

    return (
        <PosterSharePanel
            imageUrlFor={imageUrlFor}
            shareUrl={shared?.shareUrl || null}
            shareText={`My all-time Top ${size} 🎬 What's yours?`}
            shareTitle={`My All-Time Top ${size}`}
            filenameFor={(format) => `aluvo-top-${size}-${format}.png`}
            imageAlt={(format) => `Your all-time Top ${size} as a ${format} poster`}
            linkHint={`Posted links show your Top ${size} as the preview image.`}
            noLinkHint={loggedIn
                ? 'Turn on the public link when you save to get a shareable page for your list.'
                : 'Post the image anywhere — it includes aluvo.app so friends can make theirs.'}
            onTrack={onTrack}
        />
    );
}
